<template>
    <div class="animated fadeIn">

        <b-card class="card-accent-info" header="Envio">
            <b-card-body>

                <b-row>
                    <b-col md="12">
                        <b-form>
                            <b-form-group
                            description=""
                            label="URL"
                            label-for="sourceModelFolder"
                            >
                            <b-form-input v-model="url" id="sourceModelFolder" type="text"></b-form-input>
                        </b-form-group> 
                        </b-form>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col md="12">
                        <b-form>
                            <b-form-group
                            description=""
                            label="JSON Data"
                            label-for="data"
                            >
                            <textarea v-model="data" class="form-control" id="data" name="data" rows="12" placeholder=""></textarea>
                        </b-form-group> 
                        </b-form>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col md="12">
                        <b-form>
                            <b-form-group
                            description=""
                            label="Resultado"
                            label-for="resp"
                            >
                            <textarea v-model="response" class="form-control" id="resp" name="data" rows="6" placeholder=""></textarea>
                        </b-form-group> 
                        </b-form>
                    </b-col>
                </b-row>


                <div slot="footer" class="text-right">
                    <b-button variant="github" class="mr-1 btn-brand" @click="sendGet()"><i class="fa fa-check"></i><span>Enviar GET</span></b-button>
                    <b-button variant="github" class="mr-1 btn-brand" @click="sendPost()"><i class="fa fa-check"></i><span>Enviar POST</span></b-button>
                
                </div>
                
                <hr>

                <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="mdfeExecute()"><i class="fa fa-play-circle-o"></i><span>MDFe (Compsis)</span></b-button>
                <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="mdfeExecuteCart()"><i class="fa fa-play-circle-o"></i><span>MDFe (Cart)</span></b-button>
                <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="mdfeExecuteEntrevias()"><i class="fa fa-play-circle-o"></i><span>MDFe (Entrevias)</span></b-button>

                <hr>
                <b-button variant="behance" class="mr-1 btn-brand" @click="inventoryProductCount()"><i class="fa fa-play-circle-o"></i><span>Contagem</span></b-button>
                
                
            </b-card-body>
        </b-card>
      
  
    </div>
</template>
  
  <script>
  import Vue from 'vue'
  import axios from "axios";
  
  import { Switch as cSwitch } from '@coreui/vue'

  /* DataTimePicker */
  import datePicker from 'vue-bootstrap-datetimepicker';
  import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';

  /* Toast */
  import VueNotifications from 'vue-notifications'
  import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
  //import { table } from 'console'
  
  const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
  }
  
  miniToastr.init({types: toastTypes})
  
  function toast ({title, message, type, timeout, cb}) {
    return miniToastr[type](message, title, timeout, cb)
  }
  
  const options = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast
  }
  VueNotifications.setPluginOptions(options)
  
  Vue.use(VueNotifications, options)
  /* Toast - End */
  
  const newItem = {id: null, name: '', description: '', st: 'A', _rowVariant: ''}
  
  export default {
    name: 'SendPost',
    components: {
      Event,
      cSwitch,
      datePicker
    },
    data: () => {
      return {
        url: '',
        data: '',
        response: ''
      }
    },
    computed: {
     
    },
    methods: {
        async sendGet() {
            var s = this

            await axios.get(
                s.url
            ).then(function (resp) {
                s.response = JSON.stringify(resp.data)
                console.log(JSON.parse(JSON.stringify(resp.data)))
            }
            ).catch(function (error) {
                console.log(error)
                s.response = error
            })
        },

        async sendPost() {
            var s = this
            s.response = ''
            try {
                await axios.post(
                s.url,
                JSON.parse(s.data)
                ).then(function(resp) {
                    s.response = JSON.stringify(resp.data)
                    console.log(JSON.parse(JSON.stringify(resp.data)))                    
                })
                .catch(function (error) {
                    console.log(error)
                    if(error.response && error.response.data) {
                        s.response = error.response.data
                    }
                    else {
                        s.response = error
                    }
                    
                })
            }
            catch(error) {
                s.response = error
            }
        },

        mdfeExecute() {
            this.url = this.$store.state.ws_url + '/mdfe/execute',
            this.data = '{"plate":"xxx1234","code":"123456789012340", "description":"Praca Sales sentido Norte", "cnpj":"26664057000189", "uf": 35, "latitude": -20.850999, "longitude": -47.895180, "direction": "E", "certificate": "cs_services.pem", "environment": 2, "equipment": 1}'
        },

        mdfeExecuteCart() {
            this.url = this.$store.state.ws_url + '/mdfe/execute',
            this.data = '{"plate":"FWC9758", "code":"SP225", "description":"P1 SP225", "cnpj":"10531501000409", "uf": 35, "latitude": -22.45062859, "longitude": -47.17075533, "direction": "E", "certificate": "cart.pem", "environment": 2, "equipment": 1}'
        },

        mdfeExecuteEntrevias() {
            this.url = this.$store.state.ws_url + '/mdfe/execute',
            this.data = '{"plate":"SQV7I76", "code":"760330131000000", "description":"Echapora", "cnpj":"26664057000189", "uf": 35, "latitude": "-22.331037", "longitude": "-50.119926", "direction": 2, "certificate": "./entrevias.pem", "environment": 2, "equipment": 1}'
        },

        inventoryProductCount() {
            this.url = this.$store.state.ws_url + '/app/inventory/count',
            this.data = '[{"companyId": 800, "inventoryId": 2, "productId": 1028, "label": "42", "appId": "626377863fecb1f3", "userId": 102, "count": 9.21, "isFiscal": false, "userId": 104, "date": "2023-09-20T11:44:55.014Z"}]'
        }
        
    },
    mounted: function() {
     
    }
  }
  </script>
  
  <style scoped>
  table#table-transition-example .flip-list-move {
  transition: transform 1s;
  }
  </style>

